import React from "react";
import { Dialog, DialogContent, DialogTitle, useMediaQuery, Slide, useTheme, makeStyles, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function ModalBase(props) {
	const { children, title, open, close, categoryModal, fullWidth } = props;
	const classes = useStyles();
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<Dialog
			PaperProps={{ className: classes.paper }}
			maxWidth={fullWidth ? "xl" : categoryModal ? "md" : "sm"}
			fullScreen={fullScreen}
			open={open}
			TransitionComponent={Transition}
		>
			<IconButton aria-label="close" className={classes.closeButton} onClick={close}>
				<CloseIcon />
			</IconButton>
			<DialogTitle className={classes.dialogTitle}>{title}</DialogTitle>
			<DialogContent>{children}</DialogContent>
		</Dialog>
	);
}

const useStyles = makeStyles((theme) => ({
	paper: {
		borderRadius: 45,
		overflowY: "unset",
		padding: 20,
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(2),
		top: theme.spacing(2),
		color: "#FFF",
		backgroundColor: theme.palette.secondary.main,
		width: 30,
		height: 30,
		"&:hover": {
			backgroundColor: theme.palette.secondary.main,
		},
	},
	dialogTitle: {
		textAlign: "left",
		color: theme.palette.primary.main,
		padding: 0,
		"& h2": {
			fontWeight: "bold",
		},
	},
}));
